import { defineStore } from 'pinia'
import { fetchPageMeta } from '@/api/mlap/projects'

/**
 * Bootstrap for the project-scoped MLAP router pages: the feature-level meta
 * (fetched once per session) and the per-page payloads (record data — fetched
 * fresh on every client-side entry, ROUTER.md §4). Filled by the route
 * `prepare` hooks so the page components read it synchronously at setup via
 * route props.
 */
export const useMlapProjectPagesStore = defineStore('mlapProjectPages', {
  state: () => ({ mapKey: null, metaLoaded: false, pages: {}, hydratedPage: null }),
  getters: {
    pageProps: (state) => (key) => state.pages[key] ?? {}
  },
  actions: {
    hydrateMeta({ mapKey }) {
      this.mapKey = mapKey ?? null
      this.metaLoaded = true
    },
    async ensurePageMeta() {
      if (this.metaLoaded) return

      const res = await fetchPageMeta()
      this.hydrateMeta(res.data)
    },
    setPage(key, data) {
      this.pages[key] = data
    },
    // Full page load: the styxie payload serves the first render, so the
    // initial navigation's `preparePage` skips the fetch exactly once.
    hydratePage(key, data) {
      this.setPage(key, data)
      this.hydratedPage = key
    },
    async preparePage(key, fetch) {
      if (this.hydratedPage === key) {
        this.hydratedPage = null
        return
      }

      const res = await fetch()
      this.setPage(key, res.data)
    }
  }
})
